import React, { useEffect, useState } from 'react';
import { Spin, message } from 'antd';
import VendorForm from '../molecules/VendorForm';
import VendorList from '../molecules/VendorList';
import { insertVendor, updateVendor } from '../../api/VendorsContainer';

const Vendor = () => {
    const [loading, setLoading] = useState(false);
    const [vendor, setVendor] = useState('');
    const [type, setType] = useState('');
    const [recurring, setRecurring] = useState(false);
    const [updatedVendor, setUpdatedVendor] = useState(null);

    const handleVendorSubmit = async (e) => {
        e.preventDefault();

        if (vendor.trim() === '') {
            message.error('Please enter a vendor name');
            return;
        }

        setLoading(true);

        try {
            if (updatedVendor) {
                await updateVendor(updatedVendor.id, vendor, type, recurring);
                message.success('Vendor updated successfully');
                setUpdatedVendor(null);
                setVendor('');
                setType('');
                setRecurring(false);
                return;
            }

            await insertVendor({ vendor, type, recurring });
            message.success('Vendor created successfully');
            setUpdatedVendor(null);
            setVendor('');
            setType('');
            setRecurring(false);
        } catch (error) {
            if (error.code === 'DUPLICATE_VENDOR') {
                message.warning(`Vendor already exists as "${error.existingVendor.vendor}"`);
            } else {
                message.error(error.message || 'Vendor could not be saved');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleVendorClick = (record) => {
        setUpdatedVendor(record);
    };

    useEffect(() => {
        if (updatedVendor) {
            setVendor(updatedVendor?.vendor);
            setType(updatedVendor?.type || '');
            setRecurring(updatedVendor?.recurring);
        }
    }, [updatedVendor]);

    if (loading) {
        return <Spin
            size="large"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flex: 1, marginTop: -100 }}
        />;
    }

    return (
        <div className="management-page">
            {loading && <Spin size='large' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flex: 1, marginTop: -100 }} />}
            <div className="page-heading-row">
                <div className="page-heading-copy">
                    <span className="page-kicker">Master data</span>
                    <h1>Vendors</h1>
                    <p>Create, update, and review vendor records used in invoice routing.</p>
                </div>
            </div>
            <div className="management-grid">
                <section className="management-form-card">
                    <div className="card-heading">
                        <h2>{updatedVendor ? 'Update Vendor' : 'Create Vendor'}</h2>
                        <p>{updatedVendor ? 'Edit the selected vendor details.' : 'Add a vendor before attaching invoices to it.'}</p>
                    </div>
                    <VendorForm
                        vendor={vendor}
                        type={type}
                        recurring={recurring}
                        handleVendorChange={e => setVendor(e.target.value)}
                        handleTypeChange={e => setType(e.target.value)}
                        handleRecurringChange={e => setRecurring(e.target.checked)}
                        handleSubmit={handleVendorSubmit}
                        isUpdate={updatedVendor !== null}
                    />
                </section>
                <section className="management-list-card">
                    <VendorList handleVendorClick={handleVendorClick} />
                </section>
            </div>
        </div>
    );
};

export default Vendor;
